import React from 'react';
import PropTypes from 'prop-types';
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';

import { TreatmentServiceMapCard } from 'inside-out/components/shared/cards/treatmentServiceMapCard';
import TreatmentServiceMapIcon from 'inside-out/images/treatment-services-database/map-icon.png';

import { mapStyle } from './styles';

class Container extends React.PureComponent {
	static propTypes = {
		google: PropTypes.any.isRequired,
		hasInfoWindow: PropTypes.bool,
		zoom: PropTypes.number,
		markersData: PropTypes.arrayOf(
			PropTypes.shape({
				// TODO
			})
		).isRequired,
	};

	static defaultProps = {
		hasInfoWindow: false,
		zoom: 11,
	};

	state = {
		showingInfoWindow: false,
		activeMarker: null,
		selectedPlace: null,
		bounds: undefined,
	};

	componentWillReceiveProps = newProps => {
		if (this.props.markersData !== newProps.markersData) {
			this.fitBounds(newProps.markersData);
		}
	};

	onMarkerClick = (props, marker) => {
		this.setState({
			selectedPlace: props,
			activeMarker: marker,
			showingInfoWindow: true,
		});
	};

	onMapClicked = () => {
		if (this.state.showingInfoWindow) {
			this.setState({
				showingInfoWindow: false,
				activeMarker: null,
			});
		}
	};

	fitBounds = markersData => {
		const { google } = this.props;

		let bounds = new google.maps.LatLngBounds();

		markersData
			.filter(marker => {
				return !!marker.position.lat && !!marker.position.lng;
			})
			.map(marker => {
				bounds.extend(marker.position);
			});

		this.setState({ bounds });
	};

	onMapReady = (mapProps, map) => {
		this.map = map;
		this.fitBounds(this.props.markersData);
	};

	render() {
		const { hasInfoWindow, google, markersData, zoom } = this.props;
		const { activeMarker, selectedPlace, showingInfoWindow, bounds } = this.state;

		return (
			<Map
				google={google}
				zoom={zoom}
				maxZoom={15}
				onClick={this.onMapClicked}
				onReady={this.onMapReady}
				bounds={bounds}
				initialCenter={{
					lat: -33.8478792,
					lng: 150.791551,
				}}
			>
				{markersData.map((marker, i) => {
					return (
						<Marker
							key={`marker-${i}`}
							onClick={hasInfoWindow ? this.onMarkerClick : null}
							position={marker.position}
							cardData={marker.cardData}
							icon={{
								url: TreatmentServiceMapIcon,
								scaledSize: new google.maps.Size(38, 49),
								origin: new google.maps.Point(0, 0),
								anchor: new google.maps.Point(19, 49),
							}}
						/>
					);
				})}

				{hasInfoWindow && (
					<InfoWindow marker={activeMarker} visible={showingInfoWindow}>
						<div>
							{this.state.selectedPlace && <TreatmentServiceMapCard {...selectedPlace.cardData} />}
						</div>
					</InfoWindow>
				)}
			</Map>
		);
	}
}

export const TreatmentMap = GoogleApiWrapper({ apiKey: 'AIzaSyD2Q3zkSrBaxAI-ZtoYhN3gqaNIF-vWxvw' })(Container);

export class MapElement extends React.PureComponent {
	static propTypes = {
		style: PropTypes.object,
		data: PropTypes.arrayOf(PropTypes.object),
	};

	render() {
		const { style, data } = this.props;
		return (
			<div className={ mapStyle } style={ style || null }>
				<TreatmentMap markersData={ data } zoom={ 11 } hasInfoWindow={ true }/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/treatment-services/map/component.js